import type { Country, Labels } from "react-phone-number-input";
import deLabels from "react-phone-number-input/locale/de.json";
import enLabels from "react-phone-number-input/locale/en.json";

/** Keep in sync with @patient-watch/i18n LOCALE_PHONE_COUNTRY. */
const LOCALE_PHONE_COUNTRY: Record<string, Country> = {
    "en-GB": "GB",
    "de-DE": "DE",
    "da-DK": "DK",
};

export function normaliseLocaleTag(tag: string | null | undefined): string | null {
    if (!tag || typeof tag !== "string") return null;
    const trimmed = tag.trim();
    if (!trimmed) return null;
    if (trimmed in LOCALE_PHONE_COUNTRY) return trimmed;
    const lower = trimmed.toLowerCase();
    if (lower === "en" || lower.startsWith("en-")) return "en-GB";
    if (lower === "de" || lower.startsWith("de-")) return "de-DE";
    if (lower === "da" || lower.startsWith("da-")) return "da-DK";
    return null;
}

export function localeToPhoneCountry(locale: string | null | undefined): Country {
    const normalized = normaliseLocaleTag(locale);
    return normalized ? (LOCALE_PHONE_COUNTRY[normalized] ?? "GB") : "GB";
}

/** Localised country names for the phone country picker (react-phone-number-input labels). */
export function localeToPhoneLabels(locale: string | null | undefined): Labels {
    return normaliseLocaleTag(locale) === "de-DE" ? deLabels : enLabels;
}

/** Locale tag passed to react-phone-number-input `locales` prop. */
export function localeToPhoneUiLocale(locale: string | null | undefined): string {
    return normaliseLocaleTag(locale) === "de-DE" ? "de" : "en";
}
